<div class="modal-header d-flex flex-row justify-content-between">
    <h1 class="modal-title">{{ modalTitle}} Lookup</h1>
    <button type="button"
            class="btn btn-secondary"
            (click)="closeLookupModal()">
        Close
    </button>
</div>
<div class="modal-body">
    <div class="d-flex flex-column mb-3">
        <label for="availableLookupsDropdown">
            <strong>Available Lookups ({{ availableLookups.length }}):</strong>
        </label>
        <ng-select [items]="availableLookups"
                   id="availableLookupsDropdown"
                   style="width:200px"
                   [(ngModel)]="selectedLookupCategory"
                   (ngModelChange)="triggerLookup()"
                   bindValue="Lookup"
                   bindLabel="Title"
                   [disabled]="availableLookups.length <= 1">
        </ng-select>
    </div>
    <div class="mb-3">
        <label for="rowFilterInput"><strong>Filter Rows:</strong></label>
        <input type="text"
               class="form-control"
               id="rowFilterInput"
               style="width:200px"
               [(ngModel)]="filterValue"
               (ngModelChange)="filterLookupTable()"
               placeholder="Enter search text..." 
               [disabled]="retrievingLookups"/>
    </div>
    <div class="d-flex justify-content-center mb-3">
        <div class="spinner-border"
             role="status"
             *ngIf="retrievingLookups"></div>
    </div>
    <table class="table"
           *ngIf="pageRows.length > 0">
        <thead>
            <tr>
                <th *ngFor="let header of columnHeaders">
                    <button type="button"
                            class="button-link"
                            (click)="orderTableByValue(header)">
                        <strong>{{ header }}</strong>
                        <span [ngClass]="{'oi': true, 'oi-chevron-top': !reverseSortOrder, 'oi-chevron-bottom': reverseSortOrder}"
                              style="margin-left:5px;"
                              *ngIf="rowOrderValue == header"></span>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of pageRows"
                class="pointer highlight-on-hover"
                (click)="selectRow(row)">
                <td class="text-truncate"
                    *ngFor="let key of columnHeaders">
                    {{ row[key] }}
                </td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="pageRows.length == 0 && !retrievingLookups"
         class="d-flex justify-content-center mb-3">
        <span>No items available</span>
    </div>
    <div class="modal-footer d-flex flex-column justify-content-center">
        <pagination class="m-0"
                    [maxSize]="paginationData.maxPageCountDisplay"
                    [boundaryLinks]="true"
                    [totalItems]="paginationData.totalItemCount"
                    [(ngModel)]="paginationData.currentPage"
                    (pageChanged)="updatePageRows($event.page)"
                    [itemsPerPage]="paginationData.maxItemsPerPage"></pagination>
        <span>Total rows: {{ filteredRows.length }}</span>
    </div>
</div>


